import { configureStore } from "@reduxjs/toolkit";
import organizationReducer from "../redux/slices/organizationSlice";
import certConnectReducer from "../redux/slices/certConnectSlice";
import designationReducer from "../redux/slices/designationSlice";
import modalReducer from "../redux/slices/modalSlice";
import countryReducer from "../redux/slices/countrySlice";
import stateReducer from "../redux/slices/stateSlice";
import bulkUploadReducer from "./slices/bulkUploadSlice";
import ccoAdvanceReducer from "./slices/ccoAdvance";
import ccoAdvanceTab2Reducer from "./slices/ccoAdvanceTab2Slice";
import contactReducer from "./slices/contactSlice";

export const store = configureStore({
  reducer: {
    modals: modalReducer,
    organization: organizationReducer,
    contact: contactReducer,
    certConnect: certConnectReducer,
    designation: designationReducer,
    country: countryReducer,
    state: stateReducer,
    bulkUpload:bulkUploadReducer ,
    ccoAdvance: ccoAdvanceReducer,
    ccoAdvanceTab2: ccoAdvanceTab2Reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }), // thunk included automatically
  devTools: process.env.NODE_ENV !== "production",
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

